/* Showrz — compteurs, avant/après, coloris animés, barre d'achat collante, vidéo d'accueil. */
(function () {
  const calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('sz-js');

  // Compteurs (data-count="4.8" ou "127")
  const compte = (el) => {
    const fin = parseFloat(el.dataset.count.replace(',', '.'));
    const dec = (el.dataset.count.split(/[.,]/)[1] || '').length;
    const t0 = performance.now(), d = 1400;
    const pas = (t) => {
      const k = Math.min(1, (t - t0) / d), v = fin * (1 - Math.pow(1 - k, 3));
      el.textContent = v.toFixed(dec).replace('.', ',');
      if (k < 1) requestAnimationFrame(pas);
    };
    requestAnimationFrame(pas);
  };
  document.querySelectorAll('[data-count]').forEach((el) => {
    if (calme || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { compte(el); io.disconnect(); } });
    io.observe(el);
  });

  // Avant / après glissable
  document.querySelectorAll('[data-compare]').forEach((c) => {
    const r = c.querySelector('input');
    if (!r) return;
    const set = (v) => c.style.setProperty('--pos', v + '%');
    r.addEventListener('input', () => set(r.value));
    if (!calme && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        let t0 = null;
        const anim = (t) => { t0 = t0 || t; const k = Math.min(1, (t - t0) / 1600); const v = 50 + Math.sin(k * Math.PI * 2) * 22 * (1 - k); set(v); r.value = v; if (k < 1) requestAnimationFrame(anim); };
        requestAnimationFrame(anim);
      }, { threshold: 0.5 });
      io.observe(c);
    }
  });

  // Coloris en scène : défilement auto + survol
  document.querySelectorAll('[data-scene]').forEach((s) => {
    const imgs = s.querySelectorAll('[data-scene-img]'), btns = s.querySelectorAll('[data-scene-btn]'), nom = s.querySelector('[data-scene-nom]');
    let i = 0, timer = null, pause = false;
    const voir = (n) => {
      i = n;
      imgs.forEach((im, k) => im.classList.toggle('is-on', k === n));
      btns.forEach((b, k) => b.classList.toggle('is-on', k === n));
      if (nom) { nom.textContent = btns[n].dataset.nom; nom.classList.remove('pop'); void nom.offsetWidth; nom.classList.add('pop'); }
    };
    btns.forEach((b, k) => { b.addEventListener('mouseenter', () => { pause = true; voir(k); }); b.addEventListener('focus', () => { pause = true; voir(k); }); });
    s.addEventListener('mouseleave', () => { pause = false; });
    const charger = () => s.querySelectorAll('img[data-srcset]').forEach((im) => { im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-srcset'); });
    if (document.readyState === 'complete') charger(); else window.addEventListener('load', charger);
    btns.forEach((b) => b.addEventListener('pointerenter', charger, { once: true }));
    if (!calme) timer = setInterval(() => { if (!pause && !document.hidden) voir((i + 1) % imgs.length); }, 2600);
  });

  // Barre d'achat collante (page produit)
  const form = document.querySelector('[data-product-form]');
  const btn = form && form.querySelector('[data-add]');
  if (btn && 'IntersectionObserver' in window) {
    const prod = form.closest('[data-product]');
    const titre = prod && prod.querySelector('h1');
    const prix = prod && prod.querySelector('[data-price]');
    const bar = document.createElement('div');
    bar.className = 'sz-sticky';
    bar.innerHTML = `<div class="sz-container sz-sticky__in"><div class="sz-sticky__txt"><b>${titre ? titre.textContent.trim() : ''}</b><span data-sticky-prix>${prix ? prix.textContent : ''}</span></div><button type="button" class="sz-btn sz-btn--principal">${btn.dataset.label || 'Ajouter au panier'}</button></div>`;
    document.body.appendChild(bar);
    document.body.classList.add('sz-has-sticky');
    bar.querySelector('button').addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(); else btn.click(); });
    new IntersectionObserver(([e]) => bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(btn);
    if (prix) new MutationObserver(() => { bar.querySelector('[data-sticky-prix]').textContent = prix.textContent; }).observe(prix, { childList: true, characterData: true, subtree: true });
  }

  // Vidéo du hero : pas de lecture si l'utilisateur préfère moins d'animations
  const lent = navigator.connection && (navigator.connection.saveData || /(^|-)2g$/.test(navigator.connection.effectiveType || ''));
  document.querySelectorAll('[data-hero-video]').forEach((v) => {
    if (calme || lent) { v.style.display = 'none'; return; }
    const go = () => {
      const src = (window.innerWidth <= 700 && v.dataset.srcMobile) ? v.dataset.srcMobile : v.dataset.src;
      if (!src) return;
      v.src = src; v.load();
      v.play().catch(() => {});
    };
    if (document.readyState === 'complete') setTimeout(go, 300); else window.addEventListener('load', () => setTimeout(go, 300));
  });
})();
